import React from "react";
import LegalDocument from "../../components/LegalDocument";
import { TERMS_OF_SERVICE } from "../../lib/legalContent";

export default function Terms() {
  return <LegalDocument doc={TERMS_OF_SERVICE} testid="terms-page" otherLink={{ to: "/privacy", label: "Privacy Policy" }} />;
}
